import pushClevertapEvent from 'clevertap/pushClevertapEvent';
import { get } from 'lodash';
import { hasFeature } from 'utils/featureFlags';

export function openTaxConfiguration() {
  pushClevertapEvent('Open Tax Configuration');
}

export function setupTaxConfiguration() {
  pushClevertapEvent('Setup Tax Configuration');
}

export function settingCheckoutStart(settings) {
  pushClevertapEvent('Setting Checkout Start', {
    'Tax Enable': settings.enable_tax,
    'Gratuity Enable': settings.enable_gratuity,
    'Include or Add': settings.include_gratuity_tax,
    'Track Server': settings.track_server,
    'Stock Limit': settings.is_stock_limit,
    'Override Stock Limit': settings.is_override_stock_limit,
    'Rounding Enable': settings.enable_rounding,
    'Rounding Digits':
      settings.rounding_settings && settings.rounding_settings.rounding_id === 1
        ? 'THOUSANDS'
        : 'HUNDREDS',
    'Rounding Down Below':
      settings.rounding_settings &&
      settings.rounding_settings.rounding_down_amount
        ? settings.rounding_settings.rounding_down_amount
        : 'null',
  });
}

export function settingCheckoutSave(settings) {
  let taxConfigProps = {};

  if (hasFeature('enable-tax-configuration')) {
    const outlets = get(settings, 'outlets', []);
    const newOutletsBeforeDiscount = outlets.filter(
      outlet => outlet.tax_type === 'BEFORE_DISCOUNT'
    );

    const newOutletsAfterDiscount = outlets.filter(
      outlet => outlet.tax_type === 'AFTER_DISCOUNT'
    );
    taxConfigProps = {
      'Total Outlets Before Discount (New)': newOutletsBeforeDiscount.length,
      'Total Outlets After Discount (New)': newOutletsAfterDiscount.length,
    };
  }

  pushClevertapEvent('Setting Checkout Save Successful', {
    'Tax Enable': settings.enable_tax,
    'Gratuity Enable': settings.enable_gratuity,
    'Include or Add': settings.include_gratuity_tax,
    'Track Server': settings.track_server,
    'Stock Limit': !!settings.is_stock_limit,
    'Override Stock Limit': !!settings.is_override_stock_limit,
    'Rounding Enable': settings.enable_rounding,
    'Rounding Digits':
      settings.rounding_settings && settings.rounding_settings.rounding_id === 1
        ? 'THOUSANDS'
        : 'HUNDREDS',
    'Rounding Down Below':
      settings.rounding_settings &&
      settings.rounding_settings.rounding_down_amount
        ? settings.rounding_settings.rounding_down_amount
        : 'null',
    ...taxConfigProps,
  });
}

export function confirmTaxConfiguration(total) {
  pushClevertapEvent('Confirm Tax Configuration Setup', {
    'Total Outlets Before Discount (Previous)':
      total.previousOutletsBeforeDiscount,
    'Total Outlets Before Discount (New)': total.newOutletsBeforeDiscount,
    'Total Outlets After Discount (Previous)':
      total.previousOutletsAfterDiscount,
    'Total Outlets After Discount (New)': total.newOutletsAfterDiscount,
  });
}
